import Vue from "vue";
const eventBus = new Vue();
Object.freeze(eventBus);

export default eventBus;
